import { useCallback } from 'react';

interface UseAgencyInformation {
  id: number;
}

const useAgencyInformation = ({ id }: UseAgencyInformation) => {
  const handleGoShop = useCallback(() => {
    window.location.href = `/shop/${id}`;
  }, [id]);

  return { handleGoShop };
};

export default useAgencyInformation;
